import store from "../store";

export default {
    data() {
        return {
            loadingOrderSummary: false,
            shippingMethodName: null,
            applyingCoupon: false,
            couponCode: null,
            couponError: null,
        };
    },

    computed: {
        cart() {
            console.log('cart store',store.state);
            return store.state.cart;
        },

        sell() {
            console.log('sell store',store.state);
            return store.state.sell;
        },
        preorder() {
            console.log('test preorder', store.state.preorder);
            return store.state.preorder;
        },

        cartIsEmpty() {
            console.log('test cartIsEmpty');
            return store.cartIsEmpty();
        },

        sellIsEmpty() {
            console.log('test sellIsEmpty');
            return store.sellIsEmpty();
        },
        preorderIsEmpty() {
            console.log('test preorderIsEmpty');
            return store.preorderIsEmpty();
        },

        cartIsNotEmpty() {
            console.log(store);
            return !store.cartIsEmpty();
        },

        sellIsNotEmpty() {
            console.log('test sellIsNotEmpty');
            return !store.sellIsEmpty();
        },
        preorderIsNotEmpty() {
            console.log('test preorderIsNotEmpty',store);
            return !store.preorderIsEmpty();
        },

        hasShippingMethod() {
            return store.hasShippingMethod();
        },

        firstShippingMethod() {
            return Object.keys(store.state.cart.availableShippingMethods)[0];
        },

        hasCoupon() {
            return store.state.cart.coupon.code !== undefined;
        },
    },

    methods: {
        resetWallet() {
        // Your logic to reset wallet state goes here.
        // If you don't have it yet, just start with a console log:
        console.log('resetWallet called');
        
        // Example: Reset some data property or call store action
        // this.walletBalance = 0;   (if you track walletBalance in data/computed)
    },
        applyCoupon() {
            if (!this.couponCode) {
                return;
            }
            this.resetWallet()
            this.loadingOrderSummary = true;
            this.applyingCoupon = true;

            axios.post(route("cart.coupon.store"), { coupon: this.couponCode })
                .then((response) => {
                    this.couponCode = null;
                    this.couponError = null;

                    store.updateCart(response.data);
                })
                .catch((error) => {
                    this.couponError = error.response.data.message;
                })
                .finally(() => {
                    this.loadingOrderSummary = false;
                    this.applyingCoupon = false;
                });
        },

        removeCoupon() {
            this.loadingOrderSummary = true;
            this.resetWallet()
            axios
                .delete(route("cart.coupon.destroy"))
                .then((response) => {
                    store.updateCart(response.data);
                })
                .catch((error) => {
                    this.$notify(error.response.data.message);
                })
                .finally(() => {
                    this.loadingOrderSummary = false;
                });
        },

        async updateShippingMethod(shippingMethodName) {
            if (!shippingMethodName) {
                return;
            }

            this.loadingOrderSummary = true;

            this.changeShippingMethod(shippingMethodName);
            this.resetWallet()
            try {
                const response = await axios.post(
                    route("cart.shipping_method.store", {
                        ...(store.hasCoupon() && {
                            coupon_code: store.getCoupon(),
                        }),
                    }),
                    {
                        shipping_method: shippingMethodName,
                    }
                );

                store.updateCart(response.data);
            } catch (error) {
                this.$notify(error.response.data.message);
            } finally {
                this.loadingOrderSummary = false;
            }
        },
    },
};
